/**
 * @function convertFormStateToPageState フォームの情報を保持するため形式変換
 * @param {object} formState
 * @param {string | null} formState.joinDate
 * @param {string | null} formState.retireDate
 * @param {string} formState.aggregationTarget
 * @param {object} formState.conditions
 * @param {string} formState.conditions.joinDate
 * @param {string} formState.conditions.retireDate
 * @param {string} formState.conditions.leaveCount
 * @param {string | number} formState.conditions.leaveCountTimes
 * @param {string} formState.conditions.leaveCountType
 */
export function convertFormStateToPageState(formState) {
  const {
    joinDate,
    aggregationTarget,
    retireDate,
    conditions: {
      joinDate: isJoinDateEnabled,
      retireDate: isRetireDateEnabled,
      leaveCount,
      leaveCountTimes,
      leaveCountType
    }
  } = formState

  return {
    joinDate,
    retireDate,
    aggregationTarget,
    isJoinDateEnabled: !!isJoinDateEnabled,
    isRetireDateEnabled: !!isRetireDateEnabled,
    leaveCount,
    leaveCountTimes,
    leaveCountType
  }
}

/**
 * @function convertPageStateToFormState 保持の状態からフォーム型に変換
 * @param {object} formState
 * @param {string | null} formState.joinDate
 * @param {string | null} formState.retireDate
 * @param {string} formState.aggregationTarget
 * @param {string} formState.isJoinDateEnabled
 * @param {string} formState.isRetireDateEnabled
 * @param {string} formState.leaveCount
 * @param {string | number} formState.leaveCountTimes
 * @param {string} formState.leaveCountType
 */
export function convertPageStateToFormState(pageState) {
  const {
    joinDate,
    retireDate,
    aggregationTarget,
    isJoinDateEnabled,
    isRetireDateEnabled,
    leaveCount,
    leaveCountTimes,
    leaveCountType
  } = pageState

  return {
    joinDate,
    aggregationTarget,
    retireDate,
    conditions: {
      joinDate: isJoinDateEnabled,
      retireDate: isRetireDateEnabled,
      leaveCount,
      leaveCountTimes,
      leaveCountType
    }
  }
}
